import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Card } from "../../components/UI/Card/Card";
import { Header } from "../../components/UI/Header/Header";

const ScreensAdmin = () => (
  <Container>
    <Card title="CA Admin" collapsable={false}>
      <Row>
        <Col>
          <Link to="/caadmin/create">Create account</Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to="/caadmin/notify">Create Notification</Link>
        </Col>
      </Row>
    </Card>
  </Container>
);

export default ScreensAdmin;
